import { Fragment } from "react";

const TOKEN = /(\[PLACEHOLDER[^\]]*\]|\*[^*]+\*)/g;

// Renders copy strings: *word* becomes accent-coloured text, [PLACEHOLDER ...] becomes a highlighted chip.
export const Rich = ({ text = "" }) =>
  String(text)
    .split(TOKEN)
    .filter(Boolean)
    .map((part, i) => {
      if (part.startsWith("[PLACEHOLDER")) {
        return (
          <mark key={i} className="ph" data-placeholder="true">
            {part}
          </mark>
        );
      }
      if (part.startsWith("*") && part.endsWith("*")) {
        return (
          <em key={i} className="not-italic text-accent">{part.slice(1, -1)}</em>
        );
      }
      return <Fragment key={i}>{part}</Fragment>;
    });
